import { createServiceItemWithStages, getStageNote } from "../../../../../../components/BillClientModal/BillClientItem.utils";
import { BillingStageType } from "../../../../../../models/manual-service-billing/model";
export const getLastBilledStageServiceItem = _ref => {
  let {
    service,
    billingStages,
    t
  } = _ref;
  const nextAvailableStage = billingStages.filter(stage => stage.type === BillingStageType.Available).sort((a, b) => a.stageNumber - b.stageNumber)[0];
  if (!nextAvailableStage) return null;
  const {
    stageNumber
  } = nextAvailableStage;
  return createServiceItemWithStages({
    service,
    stageNumber,
    billingStages,
    note: getStageNote({
      stagesLength: billingStages.length,
      stageNumber,
      t
    })
  });
};